/**
 * Componente de autocompletado personalizado con estilos CSS.
 * @module CssAutocomplete
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} Elemento de autocompletado personalizado.
 */
import { Autocomplete, styled } from "@mui/material";

/**
 * Componente de autocompletado personalizado con estilos CSS.
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} Elemento de autocompletado personalizado.
 * @file src/components/CustomAutocomplete.jsx
 */

export const CssAutocomplete = styled(Autocomplete, {
  shouldForwardProp: (prop) => !["helper", "borderColor"].includes(prop),
})(({ theme, helper }) => ({
  width: "97%",
  fontFamily: "Lexend",
  borderRadius: 10,
  marginTop: 10,
  "& label.Mui-focused": {
    color: helper
      ? "#D32F2F"
      : theme.palette.mode === "dark"
        ? "white"
        : "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: helper
      ? "#D32F2F"
      : theme.palette.mode === "dark"
        ? "white"
        : "green",
    borderBottomLeftRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopRightRadius: 10,
    borderWidth: 3,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "&:hover fieldset": {
      borderColor: helper ? "#D32F2F" : "yellow",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
    "&.Mui-focused fieldset": {
      borderColor: helper
        ? "#D32F2F"
        : theme.palette.mode === "dark"
          ? "white"
          : "green",
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTopRightRadius: 10,
      borderWidth: 3,
    },
  },
}));
